const CashBookTable = ({ data = {} }) => {
  const summary = data.summary || {};
  const transactions = data.transactions || [];

  const formatPrice = (price) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 2,
    }).format(price);

  let runningSaldo = summary.opening_balance ?? 0;

  return (
    <div className="overflow-x-auto">
      <table className="w-full border border-collapse text-sm">
        <thead className="bg-blue-900 text-white">
          <tr>
            <th className="p-2 border">No</th>
            <th className="p-2 border">Tanggal</th>
            <th className="p-2 border">Nomor Slip</th>
            <th className="p-2 border">Perkiraan</th>
            <th className="p-2 border">Keterangan</th>
            <th className="p-2 border">Debet</th>
            <th className="p-2 border">Kredit</th>
            <th className="p-2 border">Saldo</th>
          </tr>
        </thead>
        <tbody>
          {/* SALDO SEBELUMNYA */}
          <tr className="bg-gray-100 font-bold">
            <td colSpan={7} className="p-2 text-center border">
              SALDO SEBELUMNYA
            </td>
            <td className="p-2 border text-right">{formatPrice(runningSaldo)}</td>
          </tr>

          {/* TRANSAKSI */}
          {transactions.length > 0 ? (
            transactions.map((trx, idx) => {
              // hitung running saldo manual
              runningSaldo += (trx.debit_amount || 0) - (trx.credit_amount || 0);

              return (
                <tr key={idx}>
                  <td className="p-2 border text-center">{idx + 1}</td>
                  <td className="p-2 border text-center">
                    {new Date(trx.transaction_date).toLocaleDateString("id-ID")}
                  </td>
                  <td className="p-2 border text-center">{trx.journal_number || "-"}</td>
                  <td className="p-2 border">{`${trx.account_code} ${trx.account_name}`}</td>
                  <td className="p-2 border">{trx.journal_description || trx.description || "-"}</td>
                  <td className="p-2 border text-right">{formatPrice(trx.debit_amount)}</td>
                  <td className="p-2 border text-right">{formatPrice(trx.credit_amount)}</td>
                  <td className="p-2 border text-right">{formatPrice(runningSaldo)}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={8} className="p-2 border text-center">
                Tidak Ada Data
              </td>
            </tr>
          )}

          {/* TOTAL */}
          <tr className="bg-gray-100 font-bold">
            <td colSpan={5} className="p-2 border text-center">
              Total
            </td>
            <td className="p-2 border text-right">{formatPrice(summary.total_cash_in || 0)}</td>
            <td className="p-2 border text-right">{formatPrice(summary.total_cash_out || 0)}</td>
            <td className="p-2 border text-right">{formatPrice(summary.closing_balance || runningSaldo)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CashBookTable;
